import { useTranslation } from 'react-i18next';

import { WidgetContainer } from '@pulse-web-ui/containers';

import type { Profile } from '@entities/agent-contract';

import { ColumnContainer } from '@shared/ui';

import { getContacts } from '../../utils';
import { ContactsSection } from '../contacts-section';
import { PersonalDataSection } from '../personal-data-section';
import { ProfileDocuments } from '../profile-documents';
import { SupportLinkHint } from '../support-link-hint';
import { AgentProfileContainer } from './agent-profile-container';
import { SupportLinkHintContainer } from './agent-profile.styles';

interface AgentProfileActiveProps {
  profile: Profile;
}

export const AgentProfileActive = ({ profile }: AgentProfileActiveProps) => {
  const { t } = useTranslation();
  const contacts = getContacts(profile);

  return (
    <AgentProfileContainer label={t('AGENT_PROFILE:headers.profile')}>
      <WidgetContainer>
        <ColumnContainer
          $gap={16}
          $marginBottom={24}
        >
          <PersonalDataSection profile={profile} />
          <ContactsSection contacts={contacts} />
        </ColumnContainer>
        <SupportLinkHintContainer>
          <SupportLinkHint />
        </SupportLinkHintContainer>
      </WidgetContainer>
      <ProfileDocuments />
    </AgentProfileContainer>
  );
};
